import axios from "@/axios";
export default {
    showMaterialsByCondition(search,pageInfor){/* 素材列表 */
        return axios.post(axios.dataUrl.matterManage.showMaterialsByCondition,{
            ...search,
            ...pageInfor
        })
    },
    publish(params,timerReleaseTime){/* 创建/发布营销素材 */
        return axios.post(axios.dataUrl.matterManage.publish,{
            ...params,
            timerReleaseTime
        })
    },
    modify(materialId,params,timerReleaseTime){/* 编辑营销素材 */
        return axios.post(axios.dataUrl.matterManage.modify,{
            materialId,
            ...params,
            timerReleaseTime
        })
    },
    create(params,timerReleaseTime,itemName){/* 创建/发布商品素材 */
        return axios.post(axios.dataUrl.matterManage.create,{
            ...params,
            timerReleaseTime,
            itemName
        })
    },
    edit(materialId,params,timerReleaseTime,itemName){/* 编辑商品素材 */
        return axios.post(axios.dataUrl.matterManage.edit,{
            materialId,
            ...params,
            timerReleaseTime,
            itemName
        })
    },
    showLogs(materialId,pageInfor){/* 展示日志 */
        return axios.post(axios.dataUrl.matterManage.showLogs,{
            materialId,
            ...pageInfor
        })
    },
    delete(materialId){/* 删除接口 */
        return axios.post(axios.dataUrl.matterManage.delete,{materialId})
    },
    revoke(materialId){/* 撤回 */
        return axios.post(axios.dataUrl.matterManage.revoke,{materialId})
    },
    top(materialId){/* 置顶 */
        return axios.post(axios.dataUrl.matterManage.top,{materialId})
    },
    untop(materialId){/* 取消置顶 */
        return axios.post(axios.dataUrl.matterManage.untop,{materialId})
    },
    preview(materialId){/* 预览 */
        return axios.post(axios.dataUrl.matterManage.preview,{materialId})
    },
    goodsList(search,pageInfor){
        return axios.post(axios.dataUrl.matterManage.goodsList,{
            ...search,
            ...pageInfor
        })
    },
    addVideo(videoSzie,video){/* 上传视频 */
        return axios.post(axios.dataUrl.matterManage.addVideo+videoSzie,video)
    }
}